export const ProductionSimulationProductModel = (
	json: IProductionSimulationProductModelObj,
): IProductionSimulationProductModelObjModel => {
	const {
		crm_raw_material_id,
		crm_group_id,
		mechanical_processing_coefficient,
		thermal_processing_coefficient,
		...rest
	} = json

	return {
		...rest,
		crmRawMaterialID: crm_raw_material_id,
		crmGroupID: crm_group_id,
		mechanicalProcessingCoefficient: mechanical_processing_coefficient,
		thermalProcessingCoefficient: thermal_processing_coefficient,
	}
}

export const ProductionSimulationProductOwner = (
	json: IProductionSimulationProductOwner,
): IProductionSimulationProductOwnerModel => {
	const { crm_semi_product_id, ...rest } = json

	return {
		...rest,
		crmSemiProductID: crm_semi_product_id,
	}
}

export const ProductionSimulationProductProductionStage = (
	json: IProductionSimulationProductProductionStage,
): IProductionSimulationProductProductionStageModel => {
	const { short_name, ...rest } = json

	return {
		...rest,
		shortName: short_name,
	}
}

export const ProductionSimulationProductMachineType = (
	json: IProductionSimulationProductMachineType,
): IProductionSimulationProductMachineTypeModel => {
	const { ...rest } = json

	return {
		...rest,
	}
}

export const ProductionSimulationProduct = (json: IProductionSimulationProduct): IProductionSimulationProductModel => {
	const {
		model,
		model_id,
		model_type,
		owner,
		owner_id,
		owner_type,
		production_meal,
		production_socket_id,
		production_stage,
		simulation_machine_types,
		simulation_overproduction,
		socket_name,
		total_raw_weight,
		total_weight_after_processing,
		...rest
	} = json

	return {
		...rest,
		model: model ? ProductionSimulationProductModel(model) : null,
		modelID: model_id ? model_id : null,
		modelType: model_type,
		owner:
			model_type === 'production_plan_raw_material'
				? ProductionPlanDetailsMeal(owner as IProductionOrderDetailsMeal)
				: ProductionSimulationProductOwner(owner as IProductionSimulationProductOwner),
		ownerID: owner_id,
		ownerType: owner_type,
		productionMeal: ProductionPlanDetailsMeal(production_meal),
		productionSocketID: production_socket_id,
		productionStage: ProductionSimulationProductProductionStage(production_stage),
		simulationOverproduction: simulation_overproduction,
		socketName: socket_name,
		simulationMachineTypes: simulation_machine_types.map(ProductionSimulationProductMachineType),
		totalRawWeight: total_raw_weight,
		totalWeightAfterProcessing: total_weight_after_processing,
	}
}
